<template>
  <div class="cloud-intercom-page">
    <div class="ci-body ci-body--center">
      <img
        class="ci-body__illustration ci-body__illustration--full-width"
        src="@/assets/img/intercom/intercom-app@3x.webp"
        alt=""
      >
      <h1 class="ci-body__title">
        {{ $t('Intercom.CloudIntercom.MediaPermissionPage.Title') }}
      </h1>
      <p class="ci-body__message">
        {{ $t('Intercom.CloudIntercom.MediaPermissionPage.Subtitle1') }}<br>
        {{ $t('Intercom.CloudIntercom.MediaPermissionPage.Subtitle2') }}
      </p>
      <div class="ci-permission-list">
        <div class="ci-permission-item">
          <img
            class="ci-permission-item__icon"
            src="@/assets/img/intercom/mic-on@3x.webp"
            alt=""
          >
          <div class="ci-permission-item__text-group">
            <p class="ci-permission-item__title">
              {{ $t('Intercom.CloudIntercom.MediaPermissionPage.MicTitle') }}
            </p>
            <p class="ci-permission-item__desc">
              {{ $t('Intercom.CloudIntercom.MediaPermissionPage.MicDesc') }}
            </p>
          </div>
        </div>
        <div class="ci-permission-item">
          <img
            class="ci-permission-item__icon"
            src="@/assets/img/intercom/video-call@3x.webp"
            alt=""
          >
          <div class="ci-permission-item__text-group">
            <p class="ci-permission-item__title">
              {{ $t('Intercom.CloudIntercom.MediaPermissionPage.CameraTitle') }}
            </p>
            <p class="ci-permission-item__desc">
              {{ $t('Intercom.CloudIntercom.MediaPermissionPage.CameraDesc') }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="ci-footer">
      <button
        class="ci-btn ci-btn--primary"
        :disabled="isRequesting"
        @click="requestPermission"
      >
        {{ $t('Intercom.CloudIntercom.MediaPermissionPage.Allow') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaPermissionPage',
  data () {
    return {
      isRequesting: false
    }
  },
  methods: {
    async requestPermission () {
      this.isRequesting = true
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true })
        // 立即停止所有 track，此處僅用於取得授權，通話時 CallingDialog 會重新取得
        stream.getTracks().forEach(t => t.stop())
        this.$emit('permission-granted')
      } catch {
        this.$emit('permission-denied')
      } finally {
        this.isRequesting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './cloudIntercom';

.ci-footer {
  margin-top: 16px;
}

.ci-permission-list {
  width: 100%;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.ci-permission-item {
  display: flex;
  align-items: center;
  gap: 28px;

  &__icon {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
  }

  &__text-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__title {
    font-size: map-get($fontSize,medium);
    font-weight: 600;
    color: #1f211f;
    margin: 0 0 4px;
  }

  &__desc {
    font-size: map-get($fontSize,small);
    color: #999;
    margin: 0;
  }
}
</style>
